import { lightTheme } from "@/customTheme";
const SVGComponent = (props) => (
  <svg
    width={24}
    height={25}
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M9.9758 2.78287C11.1207 1.73919 12.8717 1.73902 14.0168 2.78248L21.0164 9.21256C21.6404 9.78123 21.9961 10.5866 21.9961 11.431V19.999C21.9961 21.6564 20.6529 23 18.9961 23H16.002C15.4497 23 15.002 22.5521 15.002 21.9997V15.0052C15.002 14.4528 14.5542 14.0049 14.002 14.0049H9.99805C9.44576 14.0049 8.99805 14.4528 8.99805 15.0052V21.9997C8.99805 22.5521 8.55033 23 7.99805 23H5C3.34315 23 2 21.6564 2 19.999V11.4307C2 10.5865 2.3555 9.78126 2.9793 9.21261L9.9758 2.78287Z"
      stroke={props.fill ? props.fill : lightTheme.colors.blackGray}
      strokeWidth={2.1}
    />
  </svg>
);
export default SVGComponent;
